<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.baoguan }}</h3>
            <!-- <Tag color="success">币别</Tag>
        <currency v-model="items123.baoguan.currency"></currency> 
        <Tag color="blue">按板起步价</Tag>
        <InputNumber size="small" v-model="items123.baoguan.startPirce"></InputNumber>
        <formula v-model="items123.baoguan.formula"></formula>-->
            <div style="margin-left: auto">
                <Button v-if="false" size="small">新增表格</Button>
            </div>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <unitBoxDanjia :unit="item.list" :units="danjias" @on-change="unitChangeDanjia(item, $event)">
                </unitBoxDanjia>
                <div style="margin-left: auto">
                    <Button size="small" @click="item.list.splice(0, 100)">清空</Button>

                </div>
            </div>
            <div class="priceTable">
                <div>
                    <p>
                        报关项目
                    </p>
                    <p style="height:100px;">
                        计价方式
                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p>
                        <Input readonly :border="false" size="small" v-model="x.name"></Input>
                    </p>
                    <p>
                        <hanshu v-model="x.function"></hanshu>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hanshu from "../gongshi/hanshu.vue";
import modelData from "../baojia/modelData";
import unitBoxDanjia from "../baojia/unitBoxDanjia.vue";
export default {
    props: ["data",],
    components: { hanshu, unitBoxDanjia },
    data() {
        return {
            zidian: modelData.zidian,
            itemData: { list: [] },
            units: ['ff', 'dd'],
            danjias: [
                {
                    name: "买单",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "手册",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "无缝对接",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "香港报关",
                    select: true,
                    bgCost: 2
                },
            ],
            gongshi: {
                1: "danjia(0,'份','人民币')",
                2: "huoZhi(0/10000,0,'港元','最低')",
            }
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
        },
        getVal() {
            return this.itemData;
        },
        unitChangeDanjia(item, abc) {
            
            var list = item.list;
            var index = 0;
            for (let m = 0; m < list.length; m++) {
                if (abc.name == list[m].unit[0]) {
                    index = m;
                }
            }
            var select = abc.select;
            var name = abc.name;

            if (select) {
                //选中，添加回来
                list.push({
                    unit: [name],
                    name: name,
                    function: this.gongshi[abc.bgCost],
                    price: 0,
                });
            } else {
                //取消选中。删除

                list.splice(index, 1);
            }
        },
        //获取其他费用配置项目
        getOtherPay() {
            this.axios({
                method: "post",
                url:
                    this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
                data: {},
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                var dagouxiangmu = this.danjias;
                dagouxiangmu.length = 0;
                var list = this.itemData.list[0].list;
                list.length = 0;
                //var dalubaoguan = [], xianggangbaoguan = [],dagouxiangmu=[];

                for (let i = 0; i < data.length; i++) {
                    //大陆或香港打勾的项目，用于是否填写份数
                    if ((data[i].lable == '大陆报关' || data[i].lable == '香港报关') && (data[i].bgCost == 1 || data[i].bgCost == 2)) {
                        var obj = {
                            name: data[i].name,
                            select: true,
                            bgCost: data[i].bgCost
                        };
                        dagouxiangmu.push(obj);

                        list.push({
                            unit: [data[i].name],
                            name: data[i].name,
                            function: this.gongshi[data[i].bgCost],
                            price: 0,
                        }); 
                    };

                }

                //系统默认（0-否，1-是）

            });
        }
    },
    mounted() {
        this.tt();
        this.getOtherPay();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/baoguan.vue